import { TabItem } from '$core/MediaChat/MediaChat.interface';
export const tabs: TabItem[] = [
  {
    id: 'all',
    label: 'media_all',
    view: 'all',
  },
  {
    id: 'unlocked',
    label: 'media_unlocked',
    view: 'all',
  },
  {
    id: 'paid',
    label: 'media_paid',
    view: 'user',
  },
  {
    id: 'notPaid',
    label: 'media_not_paid',
    view: 'model',
  },
  {
    id: 'sent',
    label: 'media_sent',
    view: 'all',
  },
  {
    id: 'received',
    label: 'media_received',
    view: 'model',
  },
];
